/** Files (profile photo upload + serve URL helper). */
import client from './client';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const filesAPI = {
  uploadProfilePhoto: async (file) => {
    const fd = new FormData();
    fd.append('file', file);
    const r = await client.post('/files/profile-photo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    return r.data;
  },
  deleteProfilePhoto: async () => (await client.delete('/files/profile-photo')).data,
  getFileUrl: (fileIdOrPath) => {
    if (!fileIdOrPath) return '';
    if (/^https?:\/\//i.test(fileIdOrPath)) return fileIdOrPath;
    if (fileIdOrPath.startsWith('/api/')) return BACKEND + fileIdOrPath;
    return BACKEND + '/api/files/' + fileIdOrPath;
  },
};

export default filesAPI;
